import Model from 'ln/model/Model';

import {Asset} from '../../Asset';


export class Image extends Model {

    public constructor(json: object ) {
        super({
            asset: null,
            classIfMissing: '-missing',
            ext: 'png',
            preset: 'large',
            ...json
        });
    }

    public asset: Asset;
    public classIfMissing: string;
    public ext: string;
    public preset: string;
}
